<template>
  <div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-card v-if="!loading">
      <b-card-body>
        <validation-observer ref="timesheet" #default="{ invalid }">
          <b-form @submit.prevent="formSubmitted">
            <b-row>
              <b-col md="3">
                <b-form-group label="Job Card" label-for="jc-dropdown">
                  <validation-provider rules="required" #default="{ errors }" name="Job Card" vid="Job Card">
                    <b-form-select id="jc-dropdown" v-model="timesheetDetails.parentID" :options="JobCards"
                      @change="fetchoperations(timesheetDetails.parentID)"
                      
                      :disabled="type !== 'add'|| dis !== 'add'"  />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Operations" label-for="operation-dropdown">
                  <validation-provider rules="required" #default="{ errors }" name="Operations" vid="Operations">
                    <b-form-select id="operation-dropdown" 
                      v-model="timesheetDetails.typeID" 
                      :options="Operations" 
                      :disabled="!selectedJC || type !== 'add' || dis !== 'add'" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Approver" label-for="mc-approver">
                  <validation-provider rules="required" #default="{ errors }" name="Approver" vid="Approver">
                    <b-form-select id="mc-approver" :disabled="type !== 'add'" v-model="timesheetDetails.approverID"
                      :options="userList" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Reference" label-for="mc-reference">
                  <validation-provider rules="required" #default="{ errors }" name="Reference" vid="Reference">
                  <b-form-input :disabled="type !== 'add'" id="mc-Reference" type="text"
                    v-model="timesheetDetails.reference" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Start Time" label-for="mc-startTime">
                  <validation-provider rules="required" #default="{ errors }" name="Start Time" vid="start Time">
                    <b-form-timepicker 
                      id="mc-startTime" 
                      :min="new Date()" 
                      v-model="timesheetDetails.startTime"
                      :disabled="type !== 'add'"
                      @change="handleTimeChange"
                      locale="en">
                    </b-form-timepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="End Time" label-for="mc-endTime">
                        <validation-provider rules="required" #default="{ errors }" name="End Time" vid="end Time">
                          <b-form-timepicker 
                            id="mc-endTime" 
                            :min="new Date()" 
                            v-model="timesheetDetails.endTime"
                            :disabled="type !== 'add'"
                            @change="handleTimeChange"
                            locale="en">
                          </b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
              <b-col md="3">
                <b-form-group label="Hours Worked" label-for="mc-hours">
                  <validation-provider rules="required|min_value:0.01|max_value:24" #default="{ errors }"
                    name="Hours Worked" vid="Hours Worked">
                    <b-form-input
                      onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                      :disabled="type !== 'add'" id="mc-hours" type="text" v-model="timesheetDetails.hoursWorked" readonly />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Date" label-for="mc-date">
                  <validation-provider rules="required" #default="{ errors }" name="Date" vid="Date">
                    <b-form-datepicker :disabled="type !== 'add'" id="mc-date" :max="today"
                      v-model="timesheetDetails.date"></b-form-datepicker>
                    <!-- <flat-pickr :disabled="type === 'view'" v-model="timesheetDetails.date" class="form-control" :config="dateConfig" /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Description" label-for="mc-taskDescription">
                  <!-- <validation-provider rules="required" #default="{ errors }" name="Description" vid="Description"> -->
                    <b-form-textarea :disabled="type !== 'add'" id="mc-taskDescription" type="text"
                      v-model="timesheetDetails.taskDescription" />
                    <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
              <b-col v-if="type !== 'add'" md="6">
                <b-form-group label="Status" label-for="mc-status">
                  <validation-provider rules="required" #default="{ errors }" name="Status" vid="Status">
                    <b-form-select id="mc-status"
                      :disabled="(type === 'view' || timesheetDetails.approverID !== userId)"
                      v-model="timesheetDetails.status" :options="timesheetStatus" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col v-if="type !== 'add' && timesheetDetails.status === 'REJECTED'" md="6">
                <b-form-group label="Note" label-for="mc-note">
                  <validation-provider rules="required" #default="{ errors }" name="Note" vid="Note">
                    <b-form-input id="mc-note" :disabled="(type === 'view' || timesheetDetails.approverID !== userId)"
                      v-model="timesheetDetails.note" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="type !== 'view'">
              <b-col cols="12">
                <b-button v-if="userId !== timesheetDetails.approverID" variant="primary" class="mt-2 mr-1"
                  @click="submitTimesheet">
                  Save
                </b-button>
                <b-button v-else variant="primary" class="mt-2 mr-1" @click="submitTimesheet">
                  Update
                </b-button>
                <b-button variant="outline-secondary" type="button" class="mt-2" @click="resetTimesheet">
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormDatepicker,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BCard,
  BCardText,
  BCardBody,
  BFormTimepicker
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { customLoader, customError, customSwal, fnSortingDropdown } from '@/libs/customFn';
import '@/libs/customValidation';
import { TimesheetStatus } from '@/libs/defaultList';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BFormTimepicker,
    BFormTextarea,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.meta.type,
      dis: "",
      userData: JSON.parse(localStorage.getItem("userData")) || {},
      today: new Date().toISOString().split("T")[0],
      timesheetDetails: {
        id: null,
        parentID: null,
        typeID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        reference: null,
      },
      defaultTimesheet: {
        id: null,
        parentID: null,
        typeID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
      },
      dateConfig: {
        wrap: true,
        maxDate: new Date(),
      },
      selectedJC: null,
      JobCards: [],
      Operations: [],
      userList: [],
      userId: null,
      timesheetStatus: TimesheetStatus,
      jobCardName: "",
      jobCardData: null,
    };
  },
  computed: {
    ...mapGetters("serviceModule", {
      serviceOrderList: "serviceOrderList",
      timesheet: "timesheet",
      loading: "loading",
    }),
    ...mapGetters("jobcardModule", {
      jobcardList: "jobcards",
      loading: "loading",
    }),
    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),
    jobCardPlaceholder() {
      return this.type !== 'add' ? this.jobCardName : "Select a Job Card";
    },
  },
  methods: {
    ...mapActions("serviceModule", ["getServiceOrderListAction", "getServiceTimesheetAction", "postServiceTimesheetAction", "putServiceTimesheetAction"]),
    ...mapActions("jobcardModule", ["getJobcardListAction", "getJobcardIdAction"]),
    ...mapActions("userModule", ["getUserListByRoleAction"]),

    handleTimeChange() {
      this.calculateHoursWorked();
      this.validateTime(); 
    },

    validateTime() {
      if (this.timesheetDetails.startTime && this.timesheetDetails.endTime) {
        const start = new Date(`1970-01-01T${this.timesheetDetails.startTime}:00`);
        const end = new Date(`1970-01-01T${this.timesheetDetails.endTime}:00`);
        
        if (start >= end) {
          this.timeError = "Start time cannot be after or equal to end time.";
        } else {
          this.timeError = "";
        }
      }
    },

    calculateHoursWorked() {
      const { startTime, endTime } = this.timesheetDetails;
      if (startTime && endTime) {
        // Create Date objects for start and end times
        const start = new Date(`1970/01/01 ${startTime}`);
        const end = new Date(`1970/01/01 ${endTime}`);
        
        // Handle case where end time is on the next day
        let timeDiff = end - start;
        if (timeDiff < 0) {
          // Add 24 hours if end time is less than start time
          timeDiff += 24 * 60 * 60 * 1000;
        }

        // Calculate hours and minutes
        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        
        // Format the result with two decimal places
        const hoursDecimal = hours + (minutes / 60);
        console.log("🚀 ~ calculateHoursWorked ~ hoursDecimal", hoursDecimal)
        this.timesheetDetails.hoursWorked = hoursDecimal.toFixed(2);
      }
    },

    async resetTimesheet() {
      this.$router.push("/jobcardtimesheet/list");
    },
    async fetchjobcarddetails(id) {
  await this.getJobcardIdAction(id).then((jobcard) => {
    if (jobcard && jobcard.name) {
      this.jobCardData = jobcard; // Set job card data
      this.timesheetDetails.parentID = jobcard.id;
      this.jobCardName = jobcard.name;
    }
  });
  },
    async submitTimesheet() {
      let isValid = await this.$refs.timesheet.validate();
      if (isValid) {
        this.timesheetDetails.moduleReference = 'JobCard';

        this.timesheetDetails.employeeID = this.userData.id;

        // await this.fetchjobcarddetails(this.timesheetDetails.parentID);
        // if (this.jobCardData && Array.isArray(this.jobCardData.operationSteps)) {
        // const assignStaffList = this.jobCardData.operationSteps
        //   .map(step => step.assignStaff)
        //   .filter(staff => staff)        
        //   .join(', ');                   

        //     this.timesheetDetails.employeeID = assignStaffList;
        //     console.log("🚀 ~ submitTimesheet ~ this.timesheetDetails:", this.timesheetDetails);
        //   } else {
        //     console.error("operationSteps is missing or is not an array in jobCardData");
        // }
        if (this.type === 'add') {
          console.log("🚀 ~ submitTimesheet ~ this.timesheetDetails:", this.timesheetDetails)
          let addLoader = customLoader('Please wait while timesheet is being saved');
          await this.postServiceTimesheetAction(this.timesheetDetails)
            .then((res) => {
              if (res.errors) {
                customError(res);
              } else if(res.success) {
                customSwal(res.message);
                this.$router.push("/jobcardtimesheet/list");
              } else {
                customError(res);
              }
            })
            .catch((err) => customError(err.response.data));
            addLoader.close();
        } else {
          console.log("🚀 ~ submitTimesheet ~ this.timesheetDetails:", this.timesheetDetails)
          let updateLoader = customLoader('Please wait while timesheet is being updated');
        //   if (this.jobCardData && Array.isArray(this.jobCardData.operationSteps)) {
        // const assignStaffList = this.jobCardData.operationSteps
        //   .map(step => step.assignStaff)
        //   .filter(staff => staff)        
        //   .join(', ');                   

        //     this.timesheetDetails.employeeID = assignStaffList;
        //     console.log("🚀 ~ submitTimesheet ~ this.timesheetDetails:", this.timesheetDetails);
        //   } else {
        //     console.error("operationSteps is missing or is not an array in jobCardData");
        // }
          await this.putServiceTimesheetAction(this.timesheetDetails)
            .then((res) => {
              if (res.errors) {
                customError(res);
              } else if(res.success) {
                customSwal(res.message);
                this.$router.push("/jobcardtimesheet/list");
              } else {
                customError(res);
              }
            })
            .catch((err) => customError(err.response.message));
            updateLoader.close();
        }
      }
    },

    async fetchoperations(parentID) {
  await this.getJobcardIdAction(parentID).then((jobcardData) => {
    if (jobcardData) {
      this.jobCardData = jobcardData;
      console.log("🚀 ~ awaitthis.getJobcardIdAction ~ jobCardData:", this.jobCardData)

      if (jobcardData.operationSteps && jobcardData.operationSteps.length > 0) {
          this.Operations = jobcardData.operationSteps.map(ops => ({
            text: ops.name,
            value: ops.id,
            assignee: ops.assignStaff,
          }));
          console.log("🚀 ~ awaitthis.getProjectByIdAction ~ this.Tasks:", this.Operations)
          this.selectedJC = true;
        } else {
          console.log("No tasks available for this project.");
          this.Operations = [];
          this.selectedJC = false;
    }}
  });
  },
  },
  async mounted() {
    const modulereference = 'JobCard';
    this.dis = this.$route.params.id? "edit" : "add";
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;

    if (this.type !== 'add') {
      await this.getServiceTimesheetAction({modulereference, id: this.id});
      this.defaultTimesheet = this.timesheet;
      this.timesheetDetails = this.timesheet;
      await this.fetchoperations(this.timesheet.parentID);
     const ops = this.Operations.find(ops => {
      return ops.value === this.timesheet.typeID
    })
    if (ops) {
      this.timesheetDetails.typeID = this.timesheet.typeID;
      this.timesheetDetails.parentID = this.timesheet.parentID;
    } else {
      console.error("Task not found for the provided ID.");
    }
    }

    const { id: oprationid, jobcardId } = this.$route.params;
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[4][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;

    // if (jobcardId && uuidRegex.test(jobcardId)) {
    //   await this.getJobcardIdAction(jobcardId).then((jobcard) => {
    //     if (jobcard && jobcard.name) {
    //       this.jobCardName = jobcard.name;
    //       this.timesheetDetails.parentID = jobcard.id;

    //     }
    //   });
    // }
    if (oprationid && jobcardId) {
    await this.fetchoperations(jobcardId);
    const ops = this.Operations.find(ops => {
      return ops.value === oprationid
    })
    console.log("🚀 ~ ops ~ ops:", ops)
    if (ops) {
      this.timesheetDetails.typeID = oprationid;
      this.timesheetDetails.parentID = jobcardId;
      this.timesheetDetails.employeeID = ops.assignee;
    } else {
      console.error("Task not found for the provided ID.");
    }
  }
    await this.getJobcardListAction().then(() => {
      this.JobCards = this.jobcardList
      .map((jobcard) => { return { text: jobcard.name, value: jobcard.id.toString() }; })
    });

    await this.getUserListByRoleAction("staff").then(() => {
      let users = this.users.filter(
        (z) =>
          this.timesheetDetails.approverID === this.userId ||
          z.id !== this.userId
      );
      users = users.map((user) => {
        return { text: `${user.firstName} ${user.lastName}`, value: user.id };
      });
      this.userList = fnSortingDropdown(users);
    });

  },
  watch: {
    'timesheetDetails.typeID'(newTypeID) {
      console.log("🚀 ~ newTypeID:", newTypeID)
      const selectedops = this.Operations.find(ops => ops.value === newTypeID);
      if (selectedops) {
        this.timesheetDetails.employeeID = selectedops.assignee;
      } else {
        this.timesheetDetails.employeeID = null;
      }
    },
    'timesheetDetails.startTime': 'calculateHoursWorked',
    'timesheetDetails.endTime': 'calculateHoursWorked',
  },
};
</script>
